import { Box, Typography, Stack, ThemeProvider } from '@mui/material';
import PropTypes from 'prop-types';
import intl from 'react-intl-universal';
import { CustomDatePicker } from 'components/CustomDatePicker';
import { getDatePickerTheme } from 'components/CustomThemes';

const CustomRangePicker = ({
  isStartDatePickerOpen,
  setIsStartDatePickerOpen,
  isEndDatePickerOpen,
  setIsEndDatePickerOpen,
  timeRangeStart,
  timeRangeEnd,
  updateTimeRangeStart,
  updateTimeRangeEnd,
  darkMode,
  isMonthOnly = false,
}) => {
  return (
    <Stack direction="row" spacing={2} ml={2}>
      <Box sx={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
        <Typography
          variant="body1"
          gutterBottom
          style={{
            marginTop: '16px',
            marginRight: '18px',
            textAlign: 'right',
            alignSelf: 'stretch',
          }}>
          {intl.get('dashboard_sent_history_kenshin_time_selection_title')}
        </Typography>
      </Box>
      <ThemeProvider theme={getDatePickerTheme(darkMode)}>
        <CustomDatePicker
          isDatePickerOpen={isStartDatePickerOpen}
          setIsDatePickerOpen={setIsStartDatePickerOpen}
          selectedDate={timeRangeStart}
          setSelectedDate={(date) => {
            updateTimeRangeStart(date);
          }}
          isMonthOnly={isMonthOnly}
          labelText={intl.get('dashboard_sent_history_time_selection_from')}
        />
      </ThemeProvider>
      <ThemeProvider theme={getDatePickerTheme(darkMode)}>
        <CustomDatePicker
          isDatePickerOpen={isEndDatePickerOpen}
          setIsDatePickerOpen={setIsEndDatePickerOpen}
          selectedDate={timeRangeEnd}
          setSelectedDate={(date) => {
            updateTimeRangeEnd(date);
          }}
          isMonthOnly={isMonthOnly}
          labelText={intl.get('dashboard_sent_history_time_selection_to')}
          minDate={timeRangeStart}
        />
      </ThemeProvider>
    </Stack>
  );
};

CustomRangePicker.propTypes = {
  isStartDatePickerOpen: PropTypes.bool.isRequired,
  setIsStartDatePickerOpen: PropTypes.func.isRequired,
  isEndDatePickerOpen: PropTypes.bool.isRequired,
  setIsEndDatePickerOpen: PropTypes.func.isRequired,
  timeRangeStart: PropTypes.instanceOf(Date).isRequired,
  timeRangeEnd: PropTypes.instanceOf(Date).isRequired,
  updateTimeRangeStart: PropTypes.func.isRequired,
  updateTimeRangeEnd: PropTypes.func.isRequired,
  darkMode: PropTypes.bool,
  isMonthOnly: PropTypes.bool,
};

export default CustomRangePicker;
